import {ReportModel} from "@fedeltapointofsale/data-client";
import {ProductPriceLevelReportData} from "./product-price-level-report.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class ProductPriceLevelReportModel extends ReportModel<ProductPriceLevelReportData> {

    constructor(injector: Injector) {
        super(injector, ProductPriceLevelReportData);
    }

}
